// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3p1k4","actionsCol":"EnrolledClinics_actionsCol__uxfp4"};